import { Utils } from "@/plugins/utils"

export default {
	namespaced: true,
	state: {
		lstLxb: [],
		loading: false,
	},
	getters: {
		getLstLxb: state => state.lstLxb,
		getLoading: state => state.loading,
	},
	mutations: {
		setLstLxb(state, lstLxb) {
			state.lstLxb = lstLxb
		},
		setLoading(state, loading) {
			state.loading = loading
		},
	},
	actions: {
		async findPrograms({ commit, dispatch }) {
			commit("setLoading", true)
			await this._vm.$axios
				.get("/Financial/LaunchImport/FindPrograms")
				.then(response => {
					let lstLxb = Utils.ValidateAxiosResponse(response.data)
					commit("setLstLxb", lstLxb)
				})
				.catch(error => {
					commit("setLstLxb", [])
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					}, { root: true })
				})
			commit("setLoading", false)
		},
		async execute({ dispatch }, { dr3lote, lxbprog, file }) {
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Importando lançamentos", indeterminate: true }, { root: true })
			let formData = new FormData()
			formData.append("dr3lote", dr3lote)
			formData.append("lxbprog", lxbprog)
			if (file) formData.append("file", file)
			let payload = await this._vm.$axios
				.post("/Financial/LaunchImport/Execute", formData, { headers: { "Content-Type": "multipart/form-data" } })
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					}, { root: true })
					return null
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
	},
}
